(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[396],{

/***/ 3330:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/privacy-policy",
      function () {
        return __webpack_require__(4623);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 4623:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ privacy_policy; }
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/next-superjson-plugin@0.4.9_n4425kxx5r4jmllhb73qnfryoi/node_modules/next-superjson-plugin/tools.js
var tools = __webpack_require__(5630);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(7458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/next-mdx-remote@3.0.8_biqbaboplfbrettd7655fr4n2y/node_modules/next-mdx-remote/dist/index.js
var dist = __webpack_require__(7424);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(2983);
// EXTERNAL MODULE: ../../packages/ui/src/blocks/layout/site-layout.tsx + 2 modules
var site_layout = __webpack_require__(9293);
// EXTERNAL MODULE: ../../packages/ui/src/blocks/mdx-components/mdx-components.tsx
var mdx_components = __webpack_require__(2127);
;// CONCATENATED MODULE: ../../packages/ui/src/pages/privacy-policy.tsx




function PrivacyPolicy(param) {
    let { mdxSource , frontMatter  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(site_layout/* default */.Z, {
        title: frontMatter.title || "Privacy policy",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("article", {
                className: "prose mx-auto py-16 lg:prose-xl",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* MDXRemote */.R, {
                    ...mdxSource,
                    components: mdx_components/* MDXComponents */.t
                })
            })
        })
    });
}

;// CONCATENATED MODULE: ./src/pages/privacy-policy.tsx


var __N_SSG = true;
/* harmony default export */ var privacy_policy = ((0,tools.withSuperJSONPage)(PrivacyPolicy));


/***/ }),

/***/ 2127:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ MDXComponents; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7458);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4517);
/* harmony import */ var _components_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8527);
/* harmony import */ var _mdx_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6367);
/* harmony import */ var _mdx_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_mdx_module_scss__WEBPACK_IMPORTED_MODULE_3__);




const MDXComponents = {
    a: MDXLink,
    pre: Pre
};
function MDXLink(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_link__WEBPACK_IMPORTED_MODULE_1__/* .Link */ .r, {
        href: props.href || "",
        variant: "primary",
        children: props.children
    });
}
function Pre(param) {
    let { children , className , ...restProps } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("pre", {
        ...restProps,
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("not-prose whitespace-normal break-all md:whitespace-pre md:break-words", (_mdx_module_scss__WEBPACK_IMPORTED_MODULE_3___default().blockPre), className),
        children: children
    });
}


/***/ }),

/***/ 6367:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"blockPre":"mdx_blockPre__qYcGw"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [393,98,322,570,293,774,888,179], function() { return __webpack_exec__(3330); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);